

import { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const MyPostProduct = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const influencerId = localStorage.getItem("influencerID");
  const skeletonCount = 6;

  const fetchProducts = async () => {
    setLoading(true);
    const startTime = Date.now();
    const minLoadTime = 3000;

    try {
      const res = await axios.get(
        `https://server-side-influencer.onrender.com/influencer/product/${influencerId}`
      );
      setProducts(res.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      const elapsed = Date.now() - startTime;
      const waitTime = minLoadTime - elapsed;
      if (waitTime > 0) {
        setTimeout(() => setLoading(false), waitTime);
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <div className="flex-1 p-4 sm:p-6">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          My Affiliate Posts
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {loading
            ? Array.from({ length: skeletonCount }).map((_, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl shadow-md overflow-hidden p-4"
                >
                  <Skeleton height={192} className="mb-2" />
                  <Skeleton height={20} width={`80%`} className="mb-1" />
                  <Skeleton height={15} width={`60%`} className="mb-2" />
                  <Skeleton height={15} width={100} />
                </div>
              ))
            : products.map((product) => (
                <div
                  key={product._id}
                  className="bg-white rounded-xl shadow-md overflow-hidden transition duration-300 hover:shadow-lg"
                >
                  <img
                    src={product.image}
                    alt={product.customTitle || "Product Image"}
                    className="w-full h-44 object-cover"
                  />
                  <div className="p-3 pb-2">
                    {/* Custom Title */}
                    <h3 className="text-base font-semibold text-gray-900">
                      {product.customTitle || "No Title"}
                    </h3>

                    {/* Original Product Title */}
                    <p className="text-sm text-gray-600 italic mt-0.5">
                      {product.originalTitle || "No Product Title"}
                    </p>

                    {/* Caption */}
                    <p className="text-sm text-gray-600 truncate mt-1">
                      {product.caption || "No caption"}
                    </p>

                    {/* Clicks */}
                    <p className="text-sm text-green-700 font-medium mt-1">
                      🔁 {product.clicks} Click{product.clicks !== 1 && "s"}
                    </p>

                    {/* Price */}
                    <p className="text-sm text-indigo-600 font-semibold mt-0.5">
                      ₹{product.originalPrice?.toLocaleString() || "N/A"}
                    </p>

                    {/* Link */}
                    <a
                      href={product.shareableLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-2 text-blue-600 hover:underline text-sm"
                    >
                      Visit Link
                    </a>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default MyPostProduct;
